export default __webpack_public_path__ + "static/media/double-right.1769be36.svg";